// src/data/grammar/m5/index.js

import numbers  from './numbers.json'; 
import Was from './wasborn.json';
import pastSimple from './pastsimple.json';
import pastsimpleRegular from './pastsimpleregular.json';
import Could from './could.json';
import pastsimpleirregular from './pastsimpleirregulars.json';
import because from './because.json';
import sequencer from './sequencers.json';
import pastsimplequestion from './pastsimplequestions.json';
import subjectvsobject from './subjectvsobject.json';
import anyone from './anyone.json';
import shortquestions from './shortquestions.json';
import presentcontinuosfuture from './presentcontinuousforfuture.json';
import goingto from './goingto.json';



export const GRAMMAR_M5 = [
  ...numbers,
  ...Was,
  ...pastSimple,
  ...pastsimpleRegular,
  ...Could,
  ...pastsimpleirregular,
  ...because,   
  ...sequencer,
  ...pastsimplequestion,
  ...subjectvsobject,
  ...anyone,
  ...shortquestions,
  ...presentcontinuosfuture,
  ...goingto
];